module.exports = __webpack_public_path__ + "img/arrow-right.cd130e3e.svg";